import React, { Fragment, useState } from "react";
import { Box } from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import MediaCarouselDialog from "./MediaCarouselDialog";
import { Media } from "../models/Media";

const CustomImage = ({
  src,
  style,
  className,
  alt = "",
  onClick,
  enablePreview = false,
}) => {
  const [imageError, setImageError] = useState(src == null);
  const [openPreview, setOpenPreview] = useState(false);

  const onImageError = () => {
    setImageError(true);
  };

  const handlePreview = () => {
    setOpenPreview(true);
  };

  return (
    <Fragment>
      {imageError ? (
        <Box
          className={className}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ...style,
          }}
        >
          <ErrorOutlineIcon color="error" />
        </Box>
      ) : (
        <img
          src={src}
          alt={alt}
          className={className}
          style={
            enablePreview || onClick ? { cursor: "pointer", ...style } : style
          }
          onError={onImageError}
          onClick={onClick ?? handlePreview}
        />
      )}

      <MediaCarouselDialog
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        media={[Media.fromValues(src, Media.types.image)]}
      />
    </Fragment>
  );
};

export default CustomImage;
